import { render, staticRenderFns } from "./ApfUploadStudentPhoto.vue?vue&type=template&id=1311ba09&scoped=true"
import script from "./ApfUploadStudentPhoto.vue?vue&type=script&lang=js"
export * from "./ApfUploadStudentPhoto.vue?vue&type=script&lang=js"
import style0 from "./ApfUploadStudentPhoto.vue?vue&type=style&index=0&id=1311ba09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311ba09",
  null
  
)

export default component.exports